<template>
  <v-app class="public-app" id="app">
    <v-main style="background-color: white">
      <router-view/>
      <fin-cookie-declaration />
    </v-main>
  </v-app>
</template>

<script>
import FinCookieDeclaration from "@/components/common/FinCookieDeclaration"

export default {
  name: 'FinRegistration',
  components: {FinCookieDeclaration}
}
</script>

<style scoped>

</style>
